import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class MaintenanceInterventionTypesIndex extends Component {
  constructor(props) {
    super(props);
    this.state = { overlay:{message:'',type:'',status:'open'}, data: [], loaded: 0 };
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.locale = getLocale();
    this.loadData = this.loadData.bind(this);
    this.delete = this.delete.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
  }
  handleAlert(message, type, status, mode) { if(mode==='reset'){ this.setState({overlay:{message:'',type:'',status:'closed'}});} else { this.setState({overlay:{message, type, status}});} }
  handleLoaded(state) { if(this.state.loaded !== 2){ this.setState({loaded: state}); } }
  componentDidMount () { this.refs.request_api.header(); }
  componentDidUpdate(prevProps, prevState) { if(this.state.loaded === 1 && prevState.loaded === 0){ this.setState({loaded: 2}, this.loadData()); } }
  loadData() { var self=this; var header=this.refs.request_api.header('application/json'); Promise.resolve(header).then(function(value){
    fetch(config.get('api') + '/manutencao/intervencoes', { method:'GET', mode:'cors', headers:value }).then((r)=>r.json()).catch((e)=>{ console.error(e); }).then((responseJson)=>{
      self.refs.request_api.validate(responseJson, 'url'); if(responseJson.status==='success'){ self.setState({data: responseJson.data}); }
    }).then(()=>{ self.setState({overlay:{message:'',type:'',status:'closed'}}); });
  }); }
  ActionsButtons(cell, row) {
    return (
      <div className="btn-group">
        <Link className={'btn btn-primary btn-sm'} to={'/manutencao/intervencao/editar/' + cell}>
          <i className="fa fa-fw fa-pencil"></i>
        </Link>
        <button value={row.id} onClick={this.delete} className="btn btn-sm btn-danger"><i className="fa fa-trash"></i></button>
      </div>
    );
  }
  delete(event) { var id=event.currentTarget.value; var confirm_delete = window.confirm('Tem certeza que gostaria de deletar?');
    if(confirm_delete){ var self=this; var header=this.refs.request_api.header('application/json'); Promise.resolve(header).then(function(value){
      fetch(config.get('api') + '/manutencao/intervencao/' + id, { method:'DELETE', mode:'cors', headers:value }).then((r)=>r.json()).catch((e)=>{ console.error(e); }).then((responseJson)=>{
        self.refs.request_api.validate(responseJson, 'alert'); if(responseJson.status==='success'){ self.loadData(); }
        self.setState({overlay:{message:responseJson.message, type:responseJson.status, status:'open'}});
      });
    }); }
  }
  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Tipos de Intervenção de Manutenção</h3>
      <Link to="/manutencao/intervencao/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> Adicionar Tipo de Intervenção de Manutenção</Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: 'Sem registros'}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true}>ID</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft_model" dataSort={true}>Modelo</TableHeaderColumn>
        <TableHeaderColumn dataField="type" dataSort={true}>Tipo</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataFormat={this.ActionsButtons} dataAlign="center">Ações</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default MaintenanceInterventionTypesIndex;



// WEBPACK FOOTER //
// ./src/Components/MaintenanceInterventionTypes/MaintenanceInterventionTypesIndex.js